import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export function AuthModal({ theme, showAuth, setShowAuth, authMode, setAuthMode, authShowEmail, setAuthShowEmail }) {
  const C = (k) => {
    const d = theme === 'dark';
    const m = {
      surf:d?'#141924':'#FFFAF5',
      bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',
      txt:d?'#ffffff':'#1E1048',
      txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
      txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',
      inp:d?'rgba(255,255,255,0.05)':'rgba(139,92,246,0.06)',
    };
    return m[k]||'';
  };
  const [aEmail, setAEmail] = useState('');
  const [aPass, setAPass] = useState('');
  const [aName, setAName] = useState('');
  const [aLoading, setALoading] = useState(null);
  const [aError, setAError] = useState('');

  if (!showAuth) return null;

  const signInWithProvider = async (provider) => {
    setALoading(provider); setAError('');
    const { error: err } = await supabase.auth.signInWithOAuth({
      provider,
      options: { redirectTo: window.location.origin }
    });
    if (err) { setALoading(null); setAError(err.message); }
  };

  const signInWithEmail = async () => {
    if (!aEmail.trim() || !aPass.trim()) return;
    setALoading('email'); setAError('');
    const { error: err } = authMode === 'login'
      ? await supabase.auth.signInWithPassword({email: aEmail, password: aPass})
      : await supabase.auth.signUp({email: aEmail, password: aPass, options:{data:{full_name: aName}}});
    setALoading(null);
    if (err) { setAError(err.message); return; }
    localStorage.removeItem('okulmap_signed_out');
    setShowAuth(false); setAuthShowEmail(false);
  };

  const inputStyle = {width:'100%',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:10,padding:'11px 14px',color:C('txt'),fontSize:13,outline:'none',fontFamily:'DM Sans,sans-serif',marginBottom:10,boxSizing:'border-box'};

  return (
    <div style={{position:'fixed',inset:0,zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.75)',backdropFilter:'blur(8px)'}}
      onClick={function(e){ if(e.target === e.currentTarget) { setShowAuth(false); setAuthShowEmail(false); } }}>
      <div style={{background:C('surf'),borderRadius:20,padding:'36px 32px 40px',width:'100%',maxWidth:440,boxShadow:'0 24px 64px rgba(0,0,0,0.5)',border:'1px solid '+C('bord'),animation:'fadeIn 0.2s ease'}}
        onClick={function(e){e.stopPropagation();}}>

        {/* Header */}
        <div style={{textAlign:'center',marginBottom:28}}>
          <img src="/logo.png?v=3" alt="OkulMap" style={{height:104,objectFit:'contain',marginBottom:12}} />
          <div style={{color:C('txt'),fontSize:17,fontWeight:700,fontFamily:'Syne,sans-serif',marginBottom:6}}>OkulMap'a Giriş Yap</div>
          <div style={{color:C('txt2'),fontSize:13}}>Favoriler, takvim ve daha fazlası için</div>
        </div>

        {/* Email form */}
        {authShowEmail && (
          <>
            {authMode==='register' && <input value={aName} onChange={function(e){setAName(e.target.value);}} placeholder="Adınız" style={inputStyle}/>}
            <input value={aEmail} onChange={function(e){setAEmail(e.target.value);}} placeholder="E-posta" type="email" style={inputStyle}/>
            <input value={aPass} onChange={function(e){setAPass(e.target.value);}} placeholder="Şifre" type="password" style={{...inputStyle,marginBottom:14}}/>
            {aError && (
              <div style={{color:'#FF6B6B',fontSize:12,marginBottom:10,padding:'8px 12px',background:'rgba(255,107,107,0.1)',borderRadius:8,border:'1px solid rgba(255,107,107,0.25)'}}>
                {aError}
              </div>
            )}
            <button onClick={signInWithEmail} disabled={!!aLoading}
              style={{width:'100%',padding:13,borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:14,fontWeight:700,cursor:aLoading?'not-allowed':'pointer',fontFamily:'DM Sans,sans-serif',marginBottom:16,boxSizing:'border-box',opacity:aLoading?0.7:1}}>
              {aLoading==='email' ? 'Yükleniyor...' : (authMode==='login' ? 'Giriş Yap' : 'Hesap Oluştur')}
            </button>
          </>
        )}

        {!authShowEmail && (
          <button onClick={function(){ setAuthShowEmail(true); setAuthMode('login'); }}
            style={{width:'100%',padding:13,borderRadius:12,background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',color:'rgba(255,255,255,0.7)',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif',marginBottom:20,boxSizing:'border-box'}}>
            📧 E-posta ile Giriş Yap
          </button>
        )}

        {/* Divider */}
        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:16}}>
          <div style={{flex:1,height:1,background:C('bord')}}/>
          <span style={{color:C('txt3'),fontSize:11,fontWeight:600,letterSpacing:'0.08em'}}>VEYA SOSYAL HESAPLA</span>
          <div style={{flex:1,height:1,background:C('bord')}}/>
        </div>

        {/* Google */}
        <button onClick={function(){signInWithProvider('google');}} disabled={!!aLoading}
          style={{width:'100%',padding:'13px 16px',borderRadius:12,background:'#fff',border:'none',color:'#1a1a1a',fontSize:14,fontWeight:600,cursor:aLoading?'not-allowed':'pointer',fontFamily:'DM Sans,sans-serif',marginBottom:10,display:'flex',alignItems:'center',justifyContent:'center',gap:10,boxSizing:'border-box',boxShadow:'0 2px 12px rgba(0,0,0,0.3)',opacity:aLoading?0.6:1}}>
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          {aLoading==='google' ? 'Bekleniyor...' : 'Google ile Giriş Yap'}
        </button>

        {/* Apple */}
        <button onClick={function(){signInWithProvider('apple');}} disabled={!!aLoading}
          style={{width:'100%',padding:'13px 16px',borderRadius:12,background:'#000',border:'1px solid rgba(255,255,255,0.15)',color:'#fff',fontSize:14,fontWeight:600,cursor:aLoading?'not-allowed':'pointer',fontFamily:'DM Sans,sans-serif',marginBottom:8,display:'flex',alignItems:'center',justifyContent:'center',gap:10,boxSizing:'border-box',opacity:aLoading?0.6:1}}>
          <svg width="15" height="18" viewBox="0 0 814 1000"><path fill="#fff" d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.5-155.5-105.5c-46.5-65.3-94-164.5-94-259.4 0-153.7 100.4-234.8 199.2-234.8 56.5 0 102.5 38.1 137.5 38.1 33.9 0 87.6-40.8 153.4-40.8 24.6 0 108.2 2.4 168.2 83.5zm-150.1-168.7c29.7-35.6 51.1-84.6 51.1-133.4 0-6.5-.6-13.1-1.9-18.5-48.3 1.9-106 32.7-139.6 71.6-26.5 29.8-52.1 78.7-52.1 128.3 0 7.1 1.3 14.3 1.9 16.5 3.2.6 8.4 1.3 13.6 1.3 43.5 0 98.4-29.1 127-65.8z"/></svg>
          {aLoading==='apple' ? 'Bekleniyor...' : 'Apple ile Giriş Yap'}
        </button>

        <button onClick={function(){ setAuthShowEmail(true); setAuthMode('register'); }}
          style={{width:'100%',background:'none',border:'none',color:'rgba(255,255,255,0.4)',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif',padding:12,marginTop:4}}>
          Hesap Oluştur
        </button>
      </div>
    </div>
  );
}
